import { Fragment } from 'preact';
import { useState } from 'preact/hooks';
import Button from 'preact-material-components/Button';
import style from './style.css';

const Faq = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [expanded, setExpanded] = useState(true);
  const faqData = [
    {
      question: 'What is Cardless EMI?',
      answer: [
        'Cardless EMI powered by InstaCred is a facility that enables users to activate, utilize and manage a Cardless EMI credit line on behalf of the Bank/Lender at our merchant network.',
        'It allows you to avail a credit line that enables you to buy your favourite products and services and pay for it in equated monthly instalments (EMI) at low-interest rates. e.g. - You want to purchase a cell phone or go on a holiday that costs INR 50,000 - split the amount into equated monthly instalments, at a low-interest rate using the Cardless EMI powered by InstaCred payment option.',
      ],
    },
    {
      question: 'How does it work?',
      answer: [
        "Credit Lines are issued to you by your Bank/Lender. This Credit Line can be used to make purchases on InstaCred's Merchant Network.",
      ],
    },
    {
      question: 'Who is giving me this credit line?',
      answer: [
        "Credit Lines are issued to you by your Bank/Lender. This Credit Line can be used to make purchases on InstaCred's Merchant Network.",
      ],
    },
    {
      question: 'Are there any processing fees?',
      answer: [
        'Fees / Charges on your Loan are at the discretion of your Bank/Lender. Processing Fees, if any, will be displayed to you at the time of Transaction confirmation',
        'There is no fee for Checking your eligibility. Checking eligibility does not impact your credit score',
      ],
    },

    {
      question: 'How do I re-pay?',
      answer: [
        'The loan is issued to you by one of our Lending Partners. Repayment of EMIs also needs to be made to your Bank/Lender. The EMI amount will be auto debited from your saving accounts linked to the registered mobile number which was used at the time of transaction.',
        'To know the EMI debit date you may get in touch with your Bank/Lender.',
      ],
    },
    {
      question: 'How do I shop using Cardless EMI?',
      answer: [
        'To shop using Cardless EMI powered by InstaCred, you need to be pre-approved by one of Lending Partners (Banks / NBFCs). As a pre-approved user, you can shop at our partner merchants choosing InstaCred at the Payment Checkout page. For an updated list of Merchants and Offers, you can log in and navigate to Buy with InstaCred',
      ],
    },
  ];
  return (
    <div className={style.faqContainer}>
      <div className={style.innerFaqContainer}>
        <div className={style.faqHeader}>FAQ</div>
        <div className={style.innerSection}>
          <div className={style.faqsContainer}>
            {faqData.map((eachfaq, index) => {
              return (
                <div className={style.eachFaqContainer}>
                  <div
                    className={style.faqQuestion}
                    onClick={() => {
                      setCurrentIndex(index);
                      {
                        currentIndex === index
                          ? setExpanded(!expanded)
                          : setExpanded(true);
                      }
                    }}>
                    {eachfaq.question}
                    <div
                      className={`${
                        currentIndex === index && expanded
                          ? `${style.expandedSymbol}`
                          : `${style.collapedSymbol}`
                      }`}
                    />
                  </div>
                  {currentIndex === index && expanded && (
                    <Fragment>
                      {eachfaq.answer.map((eachanswer) => {
                        return (
                          <div className={style.faqAnswer}>{eachanswer}</div>
                        );
                      })}
                    </Fragment>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Faq;



// WEBPACK FOOTER //
// ./routes/campaign-activation/componentsVC/faq/index.js